import getMappings from './getMappingsFromMappingCards';
import _get from 'lodash/get';
import Source, { SourceType } from 'types/Source';
import MappingProps from 'types/Mapping';
import {
  REQUIRED_PROFILE_ATTR_KEYS,
  CLIENT_PRIMARY_KEY,
  ORG_TEAM_LEADER_MAPPING_REF_KEY,
  ORG_TEAM_LEADER_MAPPING_MATCH_KEY,
} from 'pages/Directory/consts';

export const REQUIRED_ATTRS_FOR_OTHER_SOURCES = [CLIENT_PRIMARY_KEY];

export const REQUIRED_ATTRS_FOR_PRIMARY_SOURCE = [
  ...REQUIRED_ATTRS_FOR_OTHER_SOURCES,
  ...REQUIRED_PROFILE_ATTR_KEYS,
];

export default function areMappingsInvalid(mappingCards: any[], source: Source) {
  const mappings = getMappings(mappingCards) as MappingProps[];
  const sourceType = source.type;
  const sourceIsPrimary = source.isPrimary;
  const orgTlRefMapping = mappings.find(m => m.destination === ORG_TEAM_LEADER_MAPPING_REF_KEY);
  const orgTlMatchMapping = mappings.find(m => m.destination === ORG_TEAM_LEADER_MAPPING_MATCH_KEY);
  const orgMappingIncomplete =
    [orgTlRefMapping, orgTlMatchMapping].filter(m => !_get(m, 'source')).length === 1;

  const allDestinations = mappings.map((m: any) => m.destination);

  const primarySourceMissingRequiredMappings = sourceIsPrimary
    ? REQUIRED_ATTRS_FOR_PRIMARY_SOURCE.filter(attr => !allDestinations.includes(attr))
    : [];

  const otherSourcesMissingRequiredMappings = !sourceIsPrimary
    ? REQUIRED_ATTRS_FOR_OTHER_SOURCES.filter(attr => !allDestinations.includes(attr))
    : [];

  if (primarySourceMissingRequiredMappings.length) {
    return 'Unique Identifer, First Name, Last Name, and Email mappings must be assigned to proceed.';
  }

  if (otherSourcesMissingRequiredMappings.length) {
    return 'The Unique Identifer must be assigned to proceed.';
  }

  if (orgMappingIncomplete) {
    return `Both “Manager Reference Property” and “Manager Match Property” must be set for the org chart mapping to be set up`;
  }

  return mappings.reduce((acc: string, mapping: any) => {
    if (
      sourceType === SourceType.GOOGLE &&
      mapping.collectionItemType === 'custom' &&
      _get(mapping, 'collectionItemCustomType', '').length === 0
    ) {
      return 'All Collection Fields with "Custom" types need their custom label. ';
    }

    return acc;
  }, '');
}
